export const FlatGlyph = '\u266D';
export const SharpGlyph = '\u266F';

export enum KeyRoot {
    C = 'C',
    Csharp = 'C#',
    Db = 'Db',
    D = 'D',
    Dsharp = 'D#',
    Eb = 'Eb',
    E = 'E',
    F = 'F',
    Fsharp = 'F#',
    Gb = 'Gb',
    G = 'G',
    Gsharp = 'G#',
    Ab = 'Ab',
    A = 'A',
    Asharp = 'A#',
    Bb = 'Bb',
    B = 'B',
}

/**
 * The available KeyRootNote params to be sent when fetching packs/samples
 *   https://api3-dev.landr.com/samplesmarketplace/swagger/index.html
 */
export enum KeyRootAPI {
    A = 'A',
    ASharpBFlat = 'ASharpBFlat',
    B = 'B',
    C = 'C',
    CSharpDFlat = 'CSharpDFlat',
    D = 'D',
    DSharpEFlat = 'DSharpEFlat',
    E = 'E',
    F = 'F',
    FSharpGFlat = 'FSharpGFlat',
    G = 'G',
    GSharpAFlat = 'GSharpAFlat',
}

export function toSharpKeyRoot(value?: KeyRoot | string): KeyRoot {
    switch (value) {
        case KeyRootAPI.A:
            return KeyRoot.A;
        case KeyRootAPI.B:
            return KeyRoot.B;
        case KeyRootAPI.C:
            return KeyRoot.C;
        case KeyRootAPI.D:
            return KeyRoot.D;
        case KeyRootAPI.E:
            return KeyRoot.E;
        case KeyRootAPI.F:
            return KeyRoot.F;
        case KeyRootAPI.G:
            return KeyRoot.G;
        case KeyRootAPI.ASharpBFlat:
            return KeyRoot.Asharp;
        case KeyRootAPI.CSharpDFlat:
            return KeyRoot.Csharp;
        case KeyRootAPI.DSharpEFlat:
            return KeyRoot.Dsharp;
        case KeyRootAPI.FSharpGFlat:
            return KeyRoot.Fsharp;
        case KeyRootAPI.GSharpAFlat:
            return KeyRoot.Gsharp;

        default:
            return KeyRoot.C;
    }
}

export function toFlatKeyRoot(value?: KeyRoot | string): KeyRoot {
    switch (value) {
        case KeyRootAPI.A:
            return KeyRoot.A;
        case KeyRootAPI.B:
            return KeyRoot.B;
        case KeyRootAPI.C:
            return KeyRoot.C;
        case KeyRootAPI.D:
            return KeyRoot.D;
        case KeyRootAPI.E:
            return KeyRoot.E;
        case KeyRootAPI.F:
            return KeyRoot.F;
        case KeyRootAPI.G:
            return KeyRoot.G;
        case KeyRootAPI.ASharpBFlat:
            return KeyRoot.Bb;
        case KeyRootAPI.CSharpDFlat:
            return KeyRoot.Db;
        case KeyRootAPI.DSharpEFlat:
            return KeyRoot.Eb;
        case KeyRootAPI.FSharpGFlat:
            return KeyRoot.Gb;
        case KeyRootAPI.GSharpAFlat:
            return KeyRoot.Ab;

        default:
            return KeyRoot.C;
    }
}

export function toKeyRootApi(keyRoot: KeyRoot | string): KeyRootAPI {
    switch (keyRoot) {
        case KeyRoot.A:
            return KeyRootAPI.A;
        case KeyRoot.Asharp:
        case KeyRoot.Bb:
        case KeyRootAPI.ASharpBFlat:
            return KeyRootAPI.ASharpBFlat;
        case KeyRoot.B:
            return KeyRootAPI.B;
        case KeyRoot.C:
            return KeyRootAPI.C;
        case KeyRoot.Csharp:
        case KeyRoot.Db:
        case KeyRootAPI.CSharpDFlat:
            return KeyRootAPI.CSharpDFlat;
        case KeyRoot.D:
            return KeyRootAPI.D;
        case KeyRoot.Dsharp:
        case KeyRoot.Eb:
        case KeyRootAPI.DSharpEFlat:
            return KeyRootAPI.DSharpEFlat;
        case KeyRoot.E:
            return KeyRootAPI.E;
        case KeyRoot.F:
            return KeyRootAPI.F;
        case KeyRoot.Fsharp:
        case KeyRoot.Gb:
        case KeyRootAPI.FSharpGFlat:
            return KeyRootAPI.FSharpGFlat;
        case KeyRoot.G:
            return KeyRootAPI.G;
        case KeyRoot.Gsharp:
        case KeyRoot.Ab:
        case KeyRootAPI.GSharpAFlat:
            return KeyRootAPI.GSharpAFlat;

        default:
            return KeyRootAPI.C;
    }
}

export enum KeySign {
    Flat = 'Flat',
    Sharp = 'Sharp',
}

export const getNormalizedRootValue = (
    root?: KeyRootAPI | string,
    sign?: KeySign | string,
): KeyRoot => {
    const normalizedRootValue =
        sign === KeySign.Sharp ? toSharpKeyRoot(root) : toFlatKeyRoot(root);

    return normalizedRootValue;
};

export const toUnicodeKeyRoot = (keyRoot: KeyRootAPI): string => {
    switch (keyRoot) {
        case KeyRootAPI.A:
            return KeyRootAPI.A;
        case KeyRootAPI.B:
            return KeyRootAPI.B;
        case KeyRootAPI.C:
            return KeyRootAPI.C;
        case KeyRootAPI.D:
            return KeyRootAPI.D;
        case KeyRootAPI.E:
            return KeyRootAPI.E;
        case KeyRootAPI.F:
            return KeyRootAPI.F;
        case KeyRootAPI.G:
            return KeyRootAPI.G;
        case KeyRootAPI.ASharpBFlat:
            return `${KeyRootAPI.A}${SharpGlyph} / ${KeyRootAPI.B}${FlatGlyph}`;
        case KeyRootAPI.CSharpDFlat:
            return `${KeyRootAPI.C}${SharpGlyph} / ${KeyRootAPI.D}${FlatGlyph}`;
        case KeyRootAPI.DSharpEFlat:
            return `${KeyRootAPI.D}${SharpGlyph} / ${KeyRootAPI.E}${FlatGlyph}`;
        case KeyRootAPI.FSharpGFlat:
            return `${KeyRootAPI.F}${SharpGlyph} / ${KeyRootAPI.G}${FlatGlyph}`;
        case KeyRootAPI.GSharpAFlat:
            return `${KeyRootAPI.G}${SharpGlyph} / ${KeyRootAPI.A}${FlatGlyph}`;

        default:
            return KeyRootAPI.C;
    }
};
